import { VehicleInfo } from '../../core/models/vehicle-info.model';

const ActionTypes = {
  GET_VEHICLE_INFO: `[VEHICLE INFO] Get Vehicle Info`,
  GET_VEHICLE_INFO_SUCCESS: `[VEHICLE INFO] Get Vehicle Info Success`,
  GET_VEHICLE_INFO_FAIL: `[VEHICLE INFO] Get Vehicle Info Fail`,

  SAVE_VEHICLE_INFO: `[VEHICLE INFO] Save Vehicle Info`,
  SAVE_VEHICLE_INFO_SUCCESS: `[VEHICLE INFO] Save Vehicle Info Success`,
  SAVE_VEHICLE_INFO_FAIL: `[VEHICLE INFO] Save Vehicle Info Fail`,

  RESET_CURRENT_VEHICLE_ID: `[VEHICLE INFO] Reset Current Vehicle Id`,
};

export class GetVehicleInfoAction {
  static type = ActionTypes.GET_VEHICLE_INFO;

  constructor(public payload: number) {
  }
}

export class GetVehicleInfoSuccessAction {
  static type = ActionTypes.GET_VEHICLE_INFO_SUCCESS;

  constructor(public payload: VehicleInfo) {
  }
}

export class GetVehicleInfoFailAction {
  static type = ActionTypes.GET_VEHICLE_INFO_FAIL;

  constructor(public payload: any) {
  }
}

export class SaveVehicleInfoAction {
  static type = ActionTypes.SAVE_VEHICLE_INFO;

  constructor(public payload: VehicleInfo) {
  }
}

export class SaveVehicleInfoSuccessAction {
  static type = ActionTypes.SAVE_VEHICLE_INFO_SUCCESS;

  constructor(public payload: VehicleInfo) {
  }
}

export class SaveVehicleInfoFailAction {
  static type = ActionTypes.SAVE_VEHICLE_INFO_FAIL;

  constructor(public payload: any) {
  }
}

export class ResetCurrentVehicleIdAction {
  static type = ActionTypes.RESET_CURRENT_VEHICLE_ID;
}
